import type { DetailedReportResponse } from "@/lib/types";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";
import type { RecordDetailRequestContext } from "@/lib/record-detail-transport";

export interface FetchRecordDetailsInputDto {
  recordId: string;
  version?: number | null;
  requestContext?: RecordDetailRequestContext;
}

/**
 * Use case: загрузка детальных данных записи.
 */
export class FetchRecordDetailsUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    input: FetchRecordDetailsInputDto
  ): Promise<DetailedReportResponse> {
    const { recordId, version = null, requestContext } = input;
    return this.gateway.getDetailedRecord(recordId, version, requestContext);
  }
}
